import http from "./http";
import websocket from './Websocket'
import Messenger from "./Messenger";

class WebSocketChat{
    constructor() {
        this.waitingFn = null
        this.inboxWaiting = null
        this.ackWaiting = null

    }

    newInboxWithMessage(inboxName, message, selectedUsers, callback){
        let payload = {'message' : message, 'recipientsId': selectedUsers, 'inboxName': inboxName}
        websocket.send({ type:'inbox_with_message', data: payload})
        callback()
    }

    ack(messageId, inboxId){
        websocket.send({ type:'chat_message_ack', data:{ message_id: messageId, inbox_id: inboxId }})
    }
    sendMessage(message, inboxId){
        websocket.send({ type:'chat_message_sended', data:{ message, inbox_id: inboxId }})
    }

    waitForNewInbox(callback){
        websocket.unregistry('new_inbox', this.inboxWaiting)
        this.inboxWaiting = callback
        websocket.registry('new_inbox',this.inboxWaiting)
    }

    waitForAck(callback){
        websocket.unregistry('chat_message_ack', this.ackWaiting)
        this.ackWaiting = callback
        websocket.registry('chat_message_ack',this.ackWaiting)
    }

    waitForNewMessages(callback, inbox, lastId, interval=0){
        websocket.unregistry('new_chat_message', this.waitingFn)
        this.waitingFn = (msg) => callback([msg.data])
        websocket.registry('new_chat_message',this.waitingFn)
    }

    stop(){
        websocket.unregistry('new_inbox', this.inboxWaiting)
        websocket.unregistry('new_chat_message', this.waitingFn)
        websocket.unregistry('chat_message_ack', this.ackWaiting)
    }
}

class AxiosPollingChat{

    constructor() {
        this.pending = false
        this.interval = false
        this.component = false
    }
    ack(messageId, inboxId){}// todo not supported via http
    waitForNewInbox(callback){}// todo not supported via http
    waitForAck(callback){} // todo not supported via http

    sendMessage(message, inboxId){
        http.post(`messenger/inbox/${inboxId}/message`,{message: message})
            .then(data=>{})
            .catch(e=>{})
    }
    waitForNewMessages(callback, inbox, lastId, interval=1000){
        this.stopWaiting()
        this.interval = setInterval(()=>{
            if(this.pending){
                return
            }

            this.pending = true
            http.get(`messenger/inbox/${inbox.id}/messages?afterId=${lastId}`).then( data => {
                callback(data.data)
                this.pending = false
            }).catch(()=>this.pending = false)
        },interval)
    }

    newInboxWithMessage(inboxName, message, selectedUsers, callback){
        let payload = {'message' : message, 'recipientsId': selectedUsers, 'inboxName': inboxName}
        http.post('messenger/inbox-with-message',payload).then(data =>{
            callback(data)
        }).catch(()=> Messenger.emitError("Cannot create message"))
    }

    stop(){
        clearInterval(this.interval)
    }
}

export default class ChatFactory{
    static getChat(){
        if(websocket.isEnabled()){
            return new WebSocketChat()
        }

        return new AxiosPollingChat()
    }
}